module.exports = __webpack_public_path__ + "img/Icon-info.e33b923a.svg";